<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="500">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Evento do Calendário
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12" class="mb-0">
                <v-text-field v-model="content.nome" label="Evento do Calendário" outlined dense
                  readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex mt-0">
              <v-col cols="3">
                <span class="text-body-1 mr-2 grey--text text--darken-1">Cor</span>
              </v-col>
              <sca-color-picker v-model="content.corHexadecimal" disabled :cols="2"></sca-color-picker>
            </v-row>
            <v-row class="d-flex align-center mt-0">
              <v-col cols="3">
                <span class="text-body-1 mr-2 grey--text text--darken-1">Dia Letivo</span>
              </v-col>
              <v-switch readonly v-model="content.diaLetivo"></v-switch>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" outlined @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { EventoCalendario } from '~/commons/classes/evento-calendario';

export default {
  props: new DialogProps(EventoCalendario)
};
</script>
